import React, { useState } from 'react';
import { Dropdown, Modal, Button, Form } from 'react-bootstrap';
import navdots from '../../../Assets/images/navdots.svg'; 
import { formatDate } from '../../../Utils/Common';
import { Link } from 'react-router-dom';
import DeleteConfirmationModal from '../../ConfirmationModal';
import TokenService from "../../../Services/Token.service";
import ConfirmationModal from '../../ConfirmationModal';
import { useMediaQuery } from 'react-responsive';

const LabTableRow = ({ lab,  handleDeleteUser, handleChangeStatus}) => {

    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const confirmDeleteUser = () => {
        handleDeleteUser(lab.id);
        handleCloseDeleteModal(); 
    };

    const [showDeactivateModal, setShowDeactivateModal] = useState(false);

    const handleShowDeactivateModal = () => setShowDeactivateModal(true);
    const handleCloseDeactivateModal = () => setShowDeactivateModal(false);

    const confirmDeactivateUser = () => {
        handleChangeStatus(lab, lab.active);
        handleCloseDeactivateModal();
    };

    

    const previousUrl = TokenService.getPrevLink();

    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <>
           {isMobile ? (
           <div className="admin-card-list">
          
             <div className="admin-card el-bg-table mb-2" >

               <div className="card-header">

               <div className="card-actions" style={{height:'10px'}}>
                <div style={{float:'right'}}>
                <div className="dropdown">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                                <img src={navdots} alt="More actions" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="el-action">
                                <Dropdown.Item as={Link}  onClick={() =>{ TokenService.updatePrevLink('/admin/lab-hours');}} to={`/admin/lab-hours/edit/${lab.id}`} state={{ lab }}>
                                    Edit
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleShowDeleteModal}>
                                    Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div> 
               </div>


                 <h5>{lab.name}</h5> 
               </div>
                
               <div className=  {"card-body "} > 
                 <p>
                   <strong>Status:</strong>{" "}
                   <span className={lab.active ? "badge bg-success" : "badge bg-danger"}>
                     {lab.active ? "Active" : "Inactive"}
                   </span>
                 </p>
               </div>
          
             </div>
           
         </div>
         ):(<>
            <tr>
                <td>{lab.name}</td>          
                <td>{lab.address}</td>   
                <td>{lab.city}</td>     
                <td>  
                    <div className={lab.active ? "el-active" : "el-inactive"}>
                        <div className={lab.active ? "el-activebtn" : "el-inactive"}></div>
                        {lab.active ? "Active" : "Inactive"}
                    </div>
                </td>     

                <td>{lab.contact_number}</td>          
                {/* <td>{lab.country}</td>          */}
                
                <td>
                    <div className="dropdown">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                                <img src={navdots} alt="More actions" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="el-action">
                                <Dropdown.Item as={Link}  onClick={() =>{ TokenService.updatePrevLink('/admin/lab-hours');}} to={`/admin/lab-hours/edit/${lab.id}`} state={{ lab }}>
                                    Edit
                                </Dropdown.Item>
                                <Dropdown.Item  onClick={handleShowDeactivateModal}>
                                <label className={lab.active ? `text-danger` : `text-success`}>
                                   {lab.active ? 'Deactivate' : 'Activate'}
                                </label>
                                </Dropdown.Item>

                                <Dropdown.Item onClick={handleShowDeleteModal}>
                                    Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </td>
            </tr>       
</>)}
            <ConfirmationModal
            show={showDeleteModal}
            onHide={handleCloseDeleteModal}
            onConfirm={confirmDeleteUser}
            title="Confirm Delete"
            body="Are you sure you want to delete this lab?"
            />
            <ConfirmationModal
                show={showDeactivateModal}
                onHide={handleCloseDeactivateModal}
                onConfirm={confirmDeactivateUser}
                title=""
                body={`Are you sure you want to ${lab.active ? 'deactivate' : 'activate'} lab?`}
                type='deactivateactivate'
            />
        </>
    );
}; 
export default LabTableRow;